export default "__VITE_ASSET__Fd7xLBoT__"